import React, { useState } from 'react';
import axios from 'axios';

const PreauthPanel = ({ booking, onUpdate }) => {
  const [amount, setAmount] = useState(200);
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const call = async (endpoint, body) => {
    setLoading(true);
    setMsg('Working...');

    try {
      const response = await axios.post(`/preauth/${endpoint}`, body);
      setMsg(JSON.stringify(response.data, null, 2));
      onUpdate();
    } catch (err) {
      setMsg(err.response?.data?.detail || 'Request failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-purple-50 border border-purple-200 rounded-lg p-4" data-testid="preauth-panel">
      <h4 className="font-semibold mb-3">🔒 Pre-Authorization</h4>
      
      <div className="mb-3">
        <label className="block text-sm font-medium mb-1">
          Hold Amount ($):
        </label>
        <input
          type="number"
          min="1"
          value={amount}
          onChange={(e) => setAmount(parseInt(e.target.value))}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          data-testid="preauth-amount-input"
        />
      </div>

      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => call('create', { booking_id: booking.id, amount_cents: Math.round(amount * 100) })}
          disabled={loading}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 text-sm"
          data-testid="create-preauth-button"
        >
          Create Preauth
        </button>
        <button
          onClick={() => call('capture', { booking_id: booking.id })}
          disabled={loading}
          className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 text-sm"
          data-testid="capture-preauth-button"
        >
          Capture Posted Amount
        </button>
        <button
          onClick={() => call('cancel', { booking_id: booking.id })}
          disabled={loading}
          className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50 text-sm"
          data-testid="cancel-preauth-button"
        >
          Cancel Preauth
        </button>
      </div>

      {msg && (
        <div className="mt-3 p-3 bg-white border border-gray-300 rounded text-xs font-mono overflow-x-auto" data-testid="preauth-message">
          <pre>{msg}</pre>
        </div>
      )}
    </div>
  );
};

export default PreauthPanel;
